import { createContext } from 'react'
import { SidebarContentContextProps } from '@/presentation/common/store/apiContext/types.ts'

export const SidebarContentContext = createContext<SidebarContentContextProps>({
  rootNode      : null,
  currentLinkId : null,
})
